/**
 * 基础BaseAPI
 * 注册 Http Engine 
 */

export default class BaseAPI {
  
}